import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormFolderShareRoleActivity, FormShareRoleActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function SharedRoles({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FormShareRoleActivity | FormFolderShareRoleActivity

  if (activity.targetType === 'FormFolder') {
    const folderInfo = (activity as FormFolderShareRoleActivity).folderInfo
    if (!folderInfo) return null

    return (
      <ItemWrapper notification={notification}>
        {activity.userName} 向你分享文件夹《{folderInfo.folderName}》
      </ItemWrapper>
    )
  }

  if (activity.targetType === 'Form') {
    const formInfo = (activity as FormShareRoleActivity).formInfo
    if (!formInfo) return null

    return (
      <ItemWrapper notification={notification}>
        {activity.userName} 向你分享表单《{formInfo.formName}》
      </ItemWrapper>
    )
  }

  return null
}
